<div fxLayout="row" fxLayoutAlign="end center">
  <div fxLayout="row" fxShow="false" fxShow.gt-xs="true" fxLayoutAlign="start center" class="search-bar">
    <input (input)="search($event)" [ngClass]="{'slideInLeft' :showsearchbar}" class="search-inputbox"
      placeholder="Type to search..." type="text">
    <button mat-icon-button (click)="showSearch()">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
